import { demutate, mutate, mutationTypes, updateWord } from './mutationUtils';

export const lowercaseMixedMutations = {
  'g': 'c\'h',
  'gw': 'w',
  'b': 'v',
  'd': 't',
  'm': 'v',
};

const mixedMutations = {
  'g': 'c\'h',
  'gw': 'w',
  'b': 'v',
  'm': 'v',
  'd': 't',
  'G': 'C\'H',
  'GW': 'W',
  'Gw': 'W',
  'B': 'V',
  'M': 'V',
  'D': 'T',
};

const reverseMutations = {
  'c\'h': 'g',
  'w': 'gw',
  'v': [ 'b', 'm' ],
  't': 'd',
  'C\'H': 'G',
  'C\'h': 'G',
  'W': 'GW',
  'V': [ 'B', 'M' ],
  'T': 'D',
};

export function applyMixedMutations (wordToMutateIdx, words) {

  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, mixedMutations, mutationTypes.MIXED);
    },
    (word) => {
      demutate(word, reverseMutations, mutationTypes.MIXED);
    });

}
